module.exports = __webpack_public_path__ + "img/banner.028c270f.jpg";